module.exports = __webpack_public_path__ + "img/20271043.a467dfec.webp";